import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"

import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { InlineSVGModule } from "ng-inline-svg"
import { MatTableModule } from "@angular/material/table"
import { MatDialogModule } from "@angular/material/dialog"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatInputModule } from "@angular/material/input"
import { MatButtonModule } from "@angular/material/button"
import { MatPaginatorIntl, MatPaginatorModule } from "@angular/material/paginator"
import { MatSortModule } from "@angular/material/sort"
import { MatIconModule } from "@angular/material/icon"
import { MatSelectModule } from "@angular/material/select"
import { MatSlideToggleModule } from "@angular/material/slide-toggle"
import { MatTabsModule } from "@angular/material/tabs"

import { TableListComponent } from "./table-list/table-list.component"
import { DataPropertyGetterPipe } from "./table-list/data-property-getter-pipe/data-property-getter.pipe"
import { MatCheckboxModule } from "@angular/material/checkbox"
import { CustomMatPaginatorIntl } from "./table-list/custom-mat-paginator-intl"
import { NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap"
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component"
import { NgbModule } from "@ng-bootstrap/ng-bootstrap"
import { MatSnackBarModule } from "@angular/material/snack-bar"
import { ExpireTokenModelComponent } from "src/app/_metronic/shared/crud-table/components/expire-token-model/expire-token-model.component"
import { FileUploadModule } from "@iplab/ngx-file-upload"
import { RouterModule } from "@angular/router"
import { SendersComponent } from "../settings/sms/senders-names/senders/senders.component"
import { AgGridTableModule } from "./shared-modules/ag-grid/ag-grid.module"
import { GoogleMapsModule } from "@angular/google-maps"
import { ClipboardModule } from "ngx-clipboard"

import { TranslateModule } from "@ngx-translate/core"
import { WrnningMessagesComponent } from "./components/wrnning-messages/wrnning-messages.component"
import { NetworksComponent } from "./components/networks/networks.component"
import { SubNetworksComponent } from "./components/networks/sub-networks/sub-networks.component"
import { SubNetworksFromComponent } from "./components/networks/sub-networks/sub-networks-from/sub-networks-from.component"
import { NetworkFormComponent } from "./components/networks/network-form/network-form.component"
import { PricingPoliciesComponent } from "./components/pricing-policies/pricing-policies.component"
import { CostCentersComponent } from "./components/cost-centers/cost-centers.component"
import { AukGridModule } from "./shared-modules/auk-grid/auk-grid.module"
import { NoDataFoundComponent } from "./components/no-data-found/no-data-found.component"
import { MatAutocompleteModule } from "@angular/material/autocomplete"
import { ShortNumberPipe } from "./pipes/short-number.pipe"
import { DebounceInputChangeDirective } from "./directives/input-change-debounce.directive"
import { GetControlPipe } from "./pipes/get-control.pipe"
import { RemoveSpaceInputDirective } from "./directives/remove.space.directive"
import { NgSelectModule } from "@ng-select/ng-select"
import { ReplaceWithStarsPipe } from "./pipes/replace-with-stars.pipe"
import { SubAccountsAutoCompleteComponent } from "./components/sub-accounts-auto-complete/sub-accounts-auto-complete.component"
import { ReMeComponentComponent } from "./components/re-me-component/re-me-component.component"
import { MatMenuModule } from "@angular/material/menu"

@NgModule({
  declarations: [
    TableListComponent,
    SendersComponent,
    DataPropertyGetterPipe,
    ConfirmDialogComponent,
    ExpireTokenModelComponent,
    WrnningMessagesComponent,
    NetworksComponent,
    SubNetworksComponent,
    SubNetworksFromComponent,
    NetworkFormComponent,
    PricingPoliciesComponent,
    CostCentersComponent,
    NoDataFoundComponent,
    ShortNumberPipe,
    DebounceInputChangeDirective,
    GetControlPipe,
    RemoveSpaceInputDirective,
    ReplaceWithStarsPipe,
    SubAccountsAutoCompleteComponent,
    ReMeComponentComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InlineSVGModule,
    MatTableModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatTabsModule,
    MatIconModule,
    NgbPaginationModule,
    NgbModule,
    MatSnackBarModule,
    FileUploadModule,
    RouterModule,
    AgGridTableModule,
    TranslateModule,
    ClipboardModule,
    AukGridModule,
    MatAutocompleteModule,
    NgSelectModule,
    MatMenuModule,
    // GoogleMapsModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    InlineSVGModule,
    MatTableModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    TableListComponent,
    MatTabsModule,
    DataPropertyGetterPipe,
    NgbPaginationModule,
    NgbModule,
    MatSnackBarModule,
    ExpireTokenModelComponent,
    FileUploadModule,
    SendersComponent,
    AgGridTableModule,
    TranslateModule,
    WrnningMessagesComponent,
    NetworksComponent,
    SubNetworksComponent,
    SubNetworksFromComponent,
    NetworkFormComponent,
    PricingPoliciesComponent,
    CostCentersComponent,
    AukGridModule,
    NoDataFoundComponent,
    ShortNumberPipe,
    DebounceInputChangeDirective,
    GetControlPipe,
    RemoveSpaceInputDirective,
    ReplaceWithStarsPipe,
    SubAccountsAutoCompleteComponent,
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginatorIntl,
    },
  ],
})
export class SharedModule {}
